import { isServerRendering } from '@farmasiet/frontendcore-reactcomponents';

import { GTMClickType } from './GTMClickType';

declare let cookieBotEnabled: boolean;

// eslint-disable-next-line @typescript-eslint/ban-types
interface DataLayerModel extends Object {
    userId?: string;
    eventCallback?: () => void;
    ecommerce?: unknown;
    email?: string;
}

export class GoogleTagManagerDataLayer {
    dataLayer: DataLayerModel[] | undefined;
    currencyCode: string;

    private eventsToSendOnConsentReady: DataLayerModel[] = [];
    private shouldWaitForCookieBotReady: boolean = typeof cookieBotEnabled !== 'undefined' ? cookieBotEnabled : false;

    constructor() {
        // eslint-disable-next-line
        this.dataLayer = typeof window !== 'undefined' ? (window as any).dataLayer : undefined;
        this.currencyCode = 'NOK';

        if (!isServerRendering() && (typeof cookieBotEnabled !== 'undefined' ? cookieBotEnabled : false)) {
            this.initCookieBotReadyEventListener();
        }
    }

    public initCookieBotReadyEventListener() {
        window.addEventListener('CookiebotOnConsentReady', () => {
            this.eventsToSendOnConsentReady.map((data) => this.dataLayer?.push(data));
            this.eventsToSendOnConsentReady = [];
            this.shouldWaitForCookieBotReady = false;
        });
    }

    public push = (obj: DataLayerModel) => {
        this.pushToDataLayer(obj);
    };

    public pushWithRedirect = (obj: DataLayerModel, url: string, clickType: GTMClickType) => {
        this.handleEventCallback(obj, url, clickType);
        this.pushToDataLayerWithFallbackRedirect(obj, url, clickType);
    };

    public addUserData = (userId?: string, hashedEmail?: string) => {
        this.pushToDataLayer({ userId: userId, email: hashedEmail });
    };

    private handleEventCallback = (data: DataLayerModel, url: string, clickType: GTMClickType) => {
        if (!clickType.isNewTab) {
            data.eventCallback = () => {
                document.location.href = url;
            };
        }
    };

    private pushToDataLayer = (data: DataLayerModel) => {
        if (this.shouldWaitForCookieBotReady) {
            this.eventsToSendOnConsentReady.push(data);
        } else {
            this.dataLayer?.push({ ecommerce: null });
            this.dataLayer?.push(data);
        }
    };

    private pushToDataLayerWithFallbackRedirect = (data: DataLayerModel, url: string, clickType: GTMClickType) => {
        this.pushToDataLayer(data);
        this.openUrl(url, clickType);
    };

    private openUrl = (url: string, clickType: GTMClickType) => {
        if (clickType.isNewTab && !clickType.isMiddleMouseButton) {
            window.open(url);
        } else if (!clickType.isNewTab && !this.isGoogleAnalyticsLoaded()) {
            document.location.href = url;
        }
    };

    private isGoogleAnalyticsLoaded = () => {
        // eslint-disable-next-line
        const googleAnalytics = (window as any).ga;
        return !this.shouldWaitForCookieBotReady && googleAnalytics && googleAnalytics.loaded;
    };
}
